import React, { useState } from 'react';
import { MdContentCopy, MdCheck } from 'react-icons/md';
import { BsLinkedin, BsGithub } from 'react-icons/bs';

import SocialMediaMobile from '../../components/SocialMediaMobile';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
// import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
  const [emailCopied, setEmailCopied] = useState(false);

  const copyEmailToClipboard = () => {
    navigator.clipboard.writeText('varan.bhalla@gmail.com');
    setEmailCopied(true);
    setTimeout(() => setEmailCopied(false), 2000);
  };

  return (
    <>
      <h2 className="head-text">Contact</h2>
      {/* <div>
        <img src={images.contactGif} />
      </div> */}
      <div className="social__media__mobile__container">
        <SocialMediaMobile />
      </div>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:varan.bhalla@gmail.com" className="p-text">varan.bhalla@gmail.com</a>
          <button
            type="button"
            className="copy-email-btn"
            onClick={copyEmailToClipboard}
            aria-label="Copy email"
            title={emailCopied ? 'Copied!' : 'Copy email'}
          >
            {emailCopied ? <MdCheck /> : <MdContentCopy />}
          </button>
        </div>

        <div className="app__footer-card app__footer-social-card">
          <div
            className="footer-social-icon"
            onClick={() => window.open('https://www.linkedin.com/in/varanbhalla', '_blank')}
            role="button"
            tabIndex={0}
            aria-label="LinkedIn"
          >
            <BsLinkedin />
          </div>
          <div
            className="footer-social-icon"
            onClick={() => window.open('https://github.com/varanbhalla', '_blank')}
            role="button"
            tabIndex={0}
            aria-label="GitHub"
          >
            <BsGithub />
          </div>
        </div>
      </div>
      {/* {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!
          </h3>
        </div>
      )} */}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
